<script>
  export let value
  export let placeholder = ""
  export let width;

  let input

  function onClickClear() {
    if (!input) return

    value = ""
    input.focus()
  }
</script>

<div class="search-input-container" style="{width ? `width: ${width}` : ''}">
  <img src="/assets/icons/icon_search_blue.svg" alt="search icon" />
  <input class="search-input" bind:value={value} bind:this={input} {placeholder} />
  <button on:click={onClickClear} disabled={!value}>
    {#if value}
      <img src="/assets/icons/icon_close_blue.svg" alt="close icon"/>
    {:else}
      <img src="/assets/icons/icon_close_gray.svg" alt="close icon"/>
    {/if}
  </button>
</div>

<style>
  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
  }
  button:disabled {
    cursor: none;
  }
  .search-input-container {
    display: inline-flex;
    flex-wrap: nowrap;
    margin: 1px;
    border: 1px solid darkgray;
    border-radius: 5px;
    padding: 4px;
    gap: 4px;
  }
  .search-input-container:has(input:focus) {
    border: 2px solid #00468f;
    margin: 0;
  }
  .search-input {
    flex: 1;
    outline: none;
    border: none
  }
  .search-input:focus {
    outline: none;
  }
</style>